export default __webpack_public_path__ + "static/media/Bonebiter.47aeb7f1.jpg";